import { makeStyles } from "@material-ui/core/styles";
import Hero1 from "../../images/hero1.jpg";

const useStyles = makeStyles((theme) => ({
  background: {
    background: `${"linear-gradient(rgba(0, 5, 10, 0.75), rgba(10, 20, 40, 0.8))"}, url(${Hero1})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
  },
}));

function BackgroundWrapper(props) {
  const classes = useStyles();
  return (
    <div className={classes.background}>
      <div
        style={{
          backdropFilter: "blur(" + props.blurValue + "px)",
          WebkitBackdropFilter: "blur(" + props.blurValue + "px)",
        }}
      >
        {props.children}
      </div>
    </div>
  );
}

export default BackgroundWrapper;
